import script from "./detail.vue?vue&type=script&lang=ts&setup=true"
export * from "./detail.vue?vue&type=script&lang=ts&setup=true"

import "./detail.vue?vue&type=style&index=0&id=a3863872&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3863872"]])

export default __exports__